"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _InfoLabel = _interopRequireDefault(require("../../../../components/InfoLabel"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var AutoLogout = function AutoLogout(_ref) {
  var fields = _ref.fields;
  var autoLogout = fields.autoLogout,
    autoLogoutTime = fields.autoLogoutTime,
    anonAutoLogoutMessage = fields.anonAutoLogoutMessage,
    individualPasscode = fields.individualPasscode,
    knownAutoLogoutMessage = fields.knownAutoLogoutMessage,
    respondentConfig = fields.respondentConfig;
  return /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: autoLogout,
    label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
      label: "Will respondents be logged out after inactivity?"
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "radio",
    style: {
      marginTop: '0'
    }
  }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
    checked: autoLogout.value,
    onChange: function onChange() {
      autoLogout.onChange(true);
    },
    type: "radio",
    value: autoLogout.value,
    style: {
      marginTop: '10px'
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'baseline'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginRight: '0.5em'
    }
  }, "Close respondent survey session after"), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: autoLogoutTime
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({}, (0, _cccisdReduxFormHelpers.domOnlyProps)(autoLogoutTime), {
    min: "1",
    className: "form-control",
    type: "number",
    style: {
      maxWidth: '75px',
      marginRight: '0.5em'
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", null, " minutes of inactivity"))), respondentConfig.value === 'anonymous' && autoLogout.value || respondentConfig.value === 'manual' && autoLogout.value && !individualPasscode.value ? /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      margin: '-1em 0 0 2em'
    }
  }, /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
    label: "Logout Message",
    tooltip: "Message to show respondents when they are automatically logged out."
  }), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    key: respondentConfig.value,
    field: respondentConfig.value === 'anonymous' ? anonAutoLogoutMessage : knownAutoLogoutMessage
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.WysiwygEditor, {
    field: respondentConfig.value === 'anonymous' ? anonAutoLogoutMessage : knownAutoLogoutMessage,
    inputStyle: {
      minHeight: '100px'
    }
  }))) : null), /*#__PURE__*/_react["default"].createElement("div", {
    className: "radio",
    style: {
      marginTop: !autoLogout.value || individualPasscode.value ? '-1.5em' : null
    }
  }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
    checked: !autoLogout.value,
    onChange: function onChange() {
      autoLogout.onChange(false);
    },
    type: "radio",
    value: !autoLogout.value
  }), "No inactivity timeout")));
};
var _default = AutoLogout;
exports["default"] = _default;
AutoLogout.propTypes = {
  fields: _propTypes["default"].object
};